import React from 'react';
import {
  Dialog,
  FlatButton,
} from 'material-ui';

export default ({ open, error, fn }) => (
  <Dialog
    open={open}
    actions={[
      <FlatButton
        label="Close"
        primary
        onClick={() => fn()}
      />,
    ]}
  >
    <h4>Send this to the developers:</h4>
    <pre>
      {JSON.stringify(error, null, 2)}
    </pre>
  </Dialog>
);
